import { render } from "./AppRadioGroup.vue?vue&type=template&id=0774dd60&scoped=true"
import script from "./AppRadioGroup.vue?vue&type=script&lang=js"
export * from "./AppRadioGroup.vue?vue&type=script&lang=js"

import "./AppRadioGroup.vue?vue&type=style&index=0&id=0774dd60&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0774dd60"]])

export default __exports__